module.exports = __webpack_public_path__ + "157ddda56ea8e707fd21a37c966b1e76.png";